<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="$router.go(-1)"
				src="../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Become Panelist
		</header>
		<main class="become-panel-container app-bottom-padding">
			<div class="d-flex flex-column align-items-center w-100">
				<div id="hideinmobile" class="cand-header d-flex mb-2">
					<img
						class="mr-3 d-flex pointer"
						src="../assets/img/homepage/back-arrow-blue.svg"
						alt=""
						@click="$router.go(-1)"
					/>
					Become a panelist
				</div>
				<div class="becpan-inside-cont">
					<section
						class="becpan-top-back"
						:class="
							primaryCandInfo.experienceLevel == 'fresher'
								? 'becpan-top-back-fresher'
								: ''
						"
					>
						<img
							id="hideinlaptop"
							class="becpan-img-3"
							src="../assets/newdesign/home/Become/WavesBackMob.png"
							alt=""
						/>
						<img
							id="hideinmobile"
							class="becpan-img-3"
							src="../assets/newdesign/home/Become/WavesBack.png"
							alt=""
						/>
						<img
							class="becpan-img-1"
							src="../assets/newdesign/home/Become/BecomePan-1.svg"
							alt=""
						/>
						<img
							class="becpan-img-2"
							src="../assets/newdesign/home/Become/BecomePan-2.svg"
							alt=""
						/>
						<img
							id="hideinlaptop"
							class="becpan-img-4"
							src="../assets/newdesign/home/Become/BecomePan-1mob.svg"
							alt=""
						/>
						<span
							class="becpan-fs-36 fw-M fam-mont text-blue z-ind-1 text-center"
							>Become a Panelist</span
						>
						<span
							class="becpan-fs-20 becpan-w-43 fw-R fam-lato text-tertiary text-center z-ind-1"
							>Join as a panelist to provide expert insights, assess candidates,
							and contribute to the hiring process</span
						>

						<div class="mob-addBtn position-relative becpan-w-13">
							<b-button
								@click="
									primaryCandInfo.experienceLevel == 'fresher'
										? $router.go(-1)
										: goToVerify()
								"
								class="w-100 fs-16"
							>
								{{
									primaryCandInfo.experienceLevel == "fresher"
										? "GO BACK"
										: "GET STARTED"
								}}
							</b-button>
							<div v-if="buttonLoader" class="loader-pos-mob">
								<Loader />
							</div>
						</div>
						<div
							v-if="primaryCandInfo.experienceLevel == 'fresher'"
							class="criteria-not-met px-3 py-2 d-flex align-items-center mx-3"
						>
							<img
								src="../assets/newdesign/BecomePanelist/cancel-panel-red.svg"
								class="mr-2"
							/>
							Experience requirements not met! Profile not qualified. Please try
							again later.
						</div>
					</section>
					<section class="ecpan-bottom-back">
						<div class="d-flex align-items-center gap-3">
							<div class="becpan-line"></div>
							<span class="fam-lato becpan-fs-20 fw-M text-grey"
								>Reasons to start</span
							>
							<div class="becpan-line"></div>
						</div>
						<div
							class="d-flex justify-content-around flex-wrap mt-3 becpan-gap-5"
						>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomePan-3.svg"
									alt=""
								/>
								<span class="text-center">Evaluate Candidate</span>
								<h4 class="mb-0">
									Panelists are responsible for rigorously assessing candidates'
									skills and qualifications during interviews.
								</h4>
							</article>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomePan-4.svg"
									alt=""
								/>
								<span class="text-center">Provide Feedback</span>
								<h4 class="mb-0">
									They provide valuable insights and feedback aimed at enhancing
									the overall selection process.
								</h4>
							</article>
							<article class="becpan-card">
								<img
									src="../assets/newdesign/home/Become/BecomePan-5.svg"
									alt=""
								/>
								<span class="text-center">Earn Income</span>
								<h4 class="mb-0">
									Panelists can generate revenue by participating in the
									interview and evaluation process.
								</h4>
							</article>
						</div>
					</section>
				</div>
				<Transition name="slidemob">
					<div v-if="showTrans" class="filter-box-mob-2">
						<RetryVerification />
					</div>
				</Transition>
			</div>
		</main>
		<b-modal id="retryVerification" centered hide-footer hide-header>
			<RetryVerification />
		</b-modal>
	</div>
</template>

<script>
import RetryVerification from "@/components/MyProfile/RetryVerification.vue";
import mobHeader from "@/components/fixedcomponents/mobileHeader.vue";
import { mapGetters } from "vuex";
import successModal from "@/components/mixin/toast";

export default {
	data() {
		return {
			isLaptop: true,
			showTrans: false,
		};
	},
	components: {
		mobHeader,
		RetryVerification,
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	mixins: [successModal],
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getPrimaryCandidateInfo",
			primaryCandInfo: "getPrimaryCandidateInfo",
		}),
	},
	methods: {
		getReverify() {
			if (this.isLaptop) {
				this.$router.push({ name: "VerifyAccount" });
				// this.$bvModal.show("retryVerification");
			} else {
				this.showTrans = true;
			}
		},
		goToVerify() {
			this.$router.push({
				name: "VerifyAccount",
			});
		},

		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
		},
	},
};
</script>

<style>
.criteria-not-met {
	background: #f0e3ea;
	z-index: 1;
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: #ad1927;
	border-radius: 4px;
}
@media (max-width: 1028px) {
	.criteria-not-met {
		font-size: var(--size-12);
	}
}
</style>
